import { Tabs, Tab } from '@heroui/react';
import React from 'react';
import { FiUser, FiUsers, FiSettings } from 'react-icons/fi';

export interface BuyerProfileTab {
  id: string;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
}

interface BuyerProfileTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const BUYER_PROFILE_TABS: BuyerProfileTab[] = [
  {
    id: 'profile',
    label: 'Profile',
    icon: FiUser,
  },
  {
    id: 'team',
    label: 'Team',
    icon: FiUsers,
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: FiSettings,
  },
];

export const BuyerProfileTabs: React.FC<BuyerProfileTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="border-b border-default-200 mb-6">
      <Tabs
        selectedKey={activeTab}
        onSelectionChange={(key) => onTabChange(key as string)}
        variant="underlined"
        classNames={{
          tabList:
            'gap-6 w-full relative rounded-none p-0 border-b border-divider',
          cursor: 'w-full bg-primary',
          tab: 'max-w-fit px-0 h-12',
          tabContent: 'group-data-[selected=true]:text-primary',
        }}
      >
        {BUYER_PROFILE_TABS.map((tab) => {
          const IconComponent = tab.icon;
          return (
            <Tab
              key={tab.id}
              title={
                <div className="flex items-center space-x-2">
                  <IconComponent size={16} />
                  <span>{tab.label}</span>
                </div>
              }
            />
          );
        })}
      </Tabs>
    </div>
  );
};
